<template>
  <b-modal
    v-model="onChangeCinemaModalModal"
    :id="getModals.signUpModalId"
    :ref="getModals.signUpModalId"
    size="lg"
    title="Select Cinema"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
  >
    <div>
      <div class="p-3">
        <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
          <div class="row my-4">
            <div class="col-12 mx-auto mb-3">
              <div class="search-city-input">
                <img src="@/assets/img/icons/search.svg" alt="search" />
                <input
                  type="search"
                  placeholder="Search cinema"
                  class="pl-5 form-control"
                  v-model="search"
                  @input="getCinemas()"
                />
              </div>
            </div>
            <div class="col-12 my-4 city-search-box">
              <!-- For one cinema name -->
              <div
                class="row mx-0"
                v-if="!isCinemasLoading && cinemas && cinemas.length === 1"
              >
                <div class="col-12 px-2 mb-2 mx-auto text-center">
                  <p
                    class="city mb-2"
                    v-for="(CinemaItem, CinemaIndex) in cinemas"
                    :key="CinemaIndex + '_' + CinemaItem.Cinema_strName"
                    @click="
                      () => {
                        selected = CinemaItem;
                        search = CinemaItem.Cinema_strName;
                        setCinema(selected);
                        onHandleCloseModal('cinemaModalModal');
                      }
                    "
                  >
                    {{ CinemaItem.Cinema_strName }}
                  </p>
                </div>
              </div>
              <div
                class="row mx-0"
                v-if="!isCinemasLoading && cinemas && cinemas.length > 1"
              >
                <div class="col-12 text-center px-2 mb-2 mx-auto">
                  <p
                    class="city mb-2"
                    v-for="(CinemaItem, CinemaIndex) in cinemas"
                    :key="CinemaIndex + '_' + CinemaItem.Cinema_strName"
                    @click="
                      () => {
                        selected = CinemaItem;
                        search = CinemaItem.Cinema_strName;
                        setCinema(selected);
                        onHandleCloseModal('cinemaModalModal');
                      }
                    "
                  >
                    {{ CinemaItem.Cinema_strName }}
                  </p>
                </div>
              </div>

              <!-- <div class="bn_cols d-none">
                <template
                  v-if="!isCinemasLoading && cinemas && cinemas.length > 0"
                >
                  <p
                    class="city mb-2 city"
                    v-for="(CinemaItem, CinemaIndex) in cinemas"
                    :key="CinemaIndex + '_' + CinemaItem.Cinema_strName"
                    @click="
                      () => {
                        selected = CinemaItem;
                        search = CinemaItem.Cinema_strName;
                        setCinema(selected);
                        onHandleCloseModal('cinemaModalModal');
                      }
                    "
                  >
                    {{ CinemaItem.Cinema_strName }}
                  </p>
                </template>
              </div> -->
            </div>
            <!-- <div class="col-6 mx-auto">
              <button
                :disabled="!selected"
                @click="
                  setCinema(selected);
                  onHandleCloseModal('cinemaModalModal');
                "
                class="btn btn-primary w-100"
              >
                Proceed
              </button>
            </div> -->
          </div>
        </div>
      </div>
      <div class="rainbow-line">
        <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Vue from "vue";
import CinemaService from "@/apiServices/CinemaService";

export default {
  data() {
    return {
      selected: null,
      cinemas: [],
      search: null,
      isCinemasLoading: false
    };
  },
  computed: {
    onChangeCinemaModalModal: {
      get() {
        return this.getModals.cinemaModalModal;
      },
      set(value) {
        !value ? this.onHandleCloseModal("cinemaModalModal") : undefined;
      }
    },
    ...mapGetters([
      // Modal
      "getModals"
    ])
  },
  beforeMount() {
    this.getCinemas();
  },
  methods: {
    ...mapActions(["onHandleOpenModal", "onHandleCloseModal", "setCinema"]),
    async getCinemas() {
      // let loader = Vue.$loading.show();
      this.isCinemasLoading = true;
      try {
        let search;
        this.search ? (search = this.search) : null;
        const response = await CinemaService.GetCinemasByCity({ search });
        const { data } = response;
        if (data && data.status) {
          this.cinemas = data.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        // loader.hide();
        this.isCinemasLoading = false;
      }
    }
  }
};
</script>

<style>
.city {
  cursor: pointer;
}
.search-city-input {
  position: relative;
}
.search-city-input img {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}
.city-search-box p {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 18px;
}
.city-search-box .state {
  color: #BF836C;
}
.city-search-box .city {
  /* color: #595858; */
  color: #fff;
  border-bottom: 1px solid #595858;
  padding-bottom: 08px;
}

.city-search-box .city:hover,
.city-search-box .city:active,
.city-search-box .city.active {
  color: var(--rose-gold);
}

.aaa {
  display: inline-block;
  float: none;
}

/* *** */

.bn_cols {
  -moz-column-count: 4;
  -moz-column-gap: 3%;
  -moz-column-width: 30%;
  -webkit-column-count: 4;
  -webkit-column-gap: 3%;
  -webkit-column-width: 30%;
  column-count: 4;
  column-gap: 3%;
  column-width: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/selectCinema.vue